import { PhoneNumber } from "../../../utils/phoneNumber";

type TProps = {
  absentee?: any
}

export const InfoCard = ({ absentee }: TProps) => { 
  return (
    <div className="flex gap-10 items-center bg-[#F8F7F7] rounded-lg p-4 mb-5">
    <div className="relative flex items-center justify-center w-20 h-20 ml-8 bg-white rounded-full shadow-xl">
      <img src="/images/Profile.svg" alt="" />
      <div className="absolute bottom-0 right-0">
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        />
      </div>
    </div>
    <div>
      <p className="text-xl font-semibold">
        {absentee?.employee.name || "No disponible"}
      </p>
      <p>
        DNI:
        <span className="ml-2 font-semibold">
          {absentee?.employee.DNI || "No disponible"}
        </span>
      </p>
      <p>
        Domicilio:
        <span className="ml-2 font-semibold">
          {absentee?.employee.fullAddress || "No disponible"}
        </span>
      </p>
      <p>
        Teléfono:
        <span className="ml-2 font-semibold">
          {absentee?.employee.phoneNumber && PhoneNumber(absentee?.employee.phoneNumber) }
        </span>
      </p>     
    </div>
  </div>
  );
};
